import React, { HTMLAttributes } from 'react'
import styled from 'styled-components'
import { getToken as token } from 'theming'

import highlightMatch from 'utils/toolset/highlightMatch'

export type HighlightMatchProps = {
  text: string
  match: string
} & HTMLAttributes<HTMLSpanElement>

const HighlightMatchWrapper = styled.span`
  /* highlightMatch splits the label into separate HTML elements, thus we need
  to preserve white-spaces, otherwise the browser wouldn't render them. */
  white-space: pre;

  mark {
    color: inherit;
    font-weight: ${token('font-weight-bold')};

    background-color: ${token('color-transparent')};
  }
`

const HighlightMatch = ({ text, match, ...props }: HighlightMatchProps): JSX.Element => {
  return <HighlightMatchWrapper {...props}>{highlightMatch(text, match)}</HighlightMatchWrapper>
}

export default HighlightMatch
